/**
 * Filter arrow component.
 */
import ArrowLeftIcon from '@components/atoms/icons/arrowLeft';
import useList from '@shared/components/utils/hooks/useList';
import { magicRemoteSelector } from '@shared/store/slices/magicRemote.slice';
import { useAppSelector } from '@shared/store/hooks';

/**
 * Filter arrow component.
 * Renders the filter arrow with an arrow left icon if the list index is greater than 1.
 */
export default function FilterArrow() {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listIndex } = useList(0);
  return !enabled && listIndex > 1 ? <ArrowLeftIcon height={24} /> : null;
}
